// NATIVE 
import * as React from 'react';


// INSTALLED 
import { Grid } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import { styled } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';


// CUSTOM 
import { DetalleArea } from '../../areas/detalle/DetalleArea';




const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));



/**
 * DetalleDialogArea component renders a modal dialog with detailed information about an area.
 * 
 * @param {object} props - The properties object.
 * @param {boolean} props.open - Determines whether the dialog is open or closed.
 * @param {function} props.handleCloseModalDetail - Function to handle closing the modal dialog.
 * @param {boolean} [props.buttons=false] - Optional flag to determine if buttons should be displayed.
 * 
 * @returns {JSX.Element} The rendered DetalleDialogArea component.
 */
export const DetalleDialogArea = (props:any) =>  {


  //  PROPS 
  const{ open, handleCloseModalDetail, buttons = false } = props;


  
  // CONST FUNCTIONS 
  const handleClose = () => {
    handleCloseModalDetail(false);
  };

  
  

  return (
    <React.Fragment>
      
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        fullWidth={true}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
           Detalle Area
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers>
        
   
        <Grid  >
            <DetalleArea />
        </Grid>
       
        </DialogContent>
        <DialogActions>
        </DialogActions>
      </BootstrapDialog>
    </React.Fragment>
  );
}




